import { useState } from "react";
import { movies } from "@/mocks/movies";
import { genres } from "@/mocks/content";
import SectionHeading from "./SectionHeading";
import MovieCard from "./MovieCard";

export default function GenreExplorer() {
  const [active, setActive] = useState("全部");

  const list = active === "全部" ? movies : movies.filter((m) => m.genre === active);

  return (
    <section id="genres" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="按类型找片"
          title="先定类型，再从本页片单里挑"
          description="点击下面的类型标签即可筛选本页已收录的电影，选中「全部」可恢复完整列表。筛选只在当前页面内进行，结果即时更新。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {genres.map((genre) => {
            const isActive = genre === active;
            return (
              <button
                key={genre}
                type="button"
                onClick={() => setActive(genre)}
                aria-pressed={isActive}
                className={`cursor-pointer rounded-full px-4 py-2 font-label text-sm whitespace-nowrap transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100"
                }`}
              >
                {genre}
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex items-center justify-between border-b border-background-200 pb-3">
          <p className="font-label text-sm text-foreground-700">
            当前筛选：
            <span className="font-medium text-accent-700">{active}</span>
          </p>
          <p className="font-label text-xs text-foreground-500">
            共 {list.length} 部影片
          </p>
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {list.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <p className="mt-10 rounded-lg bg-background-100 p-6 text-center font-label text-sm text-foreground-600">
            该类型暂时没有收录影片，换一个类型看看？
          </p>
        )}
      </div>
    </section>
  );
}